export const getContentWithSearchHighlited = (content: string, words: string[]) => {
    words.forEach(word => {
        if (content.toLocaleLowerCase().includes(word.toLocaleLowerCase())) {
            const regex = new RegExp(`\\b${word}\\b`, 'gi');
            content = content.replace(regex, match => `<span class="matched-word">${match}</span>`);
        }
    });
    return content;
};
